import React from 'react';

export default function PrivacyModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Privacy Policy</h2>
        <div className="text-gray-700 space-y-6 text-sm leading-relaxed max-h-[65vh] overflow-y-auto pr-2">
          
          <section>
            <h3 className="font-semibold text-base mb-1">1. Introduction</h3>
            <p>
              At <strong>Poppyruz</strong>, your privacy is important to us. This policy explains what information we collect, how we use it, and your rights regarding your data.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">2. Information We Collect</h3>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Your email, name, and profile info during registration</li>
              <li>Uploaded book files and custom themes</li>
              <li>Browser and device information (for analytics)</li>
              <li>Usage data for improving app experience</li>
            </ul>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">3. How We Use Your Data</h3>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>To deliver and personalize your reading experience</li>
              <li>To improve product features and security</li>
              <li>To provide customer support and account access</li>
              <li>To process payments (if applicable)</li>
              <li>To serve ads (for non-premium users)</li>
            </ul>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">4. Cookies & Tracking</h3>
            <p>
              We may use cookies and similar technologies to track your activity, enhance site performance, and personalize content. You can disable cookies in your browser settings.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">5. Third-Party Services</h3>
            <p>
              We use trusted services like Google AdSense, analytics tools, and payment processors. These may collect limited data as part of their operations, in compliance with their respective policies.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">6. Data Security</h3>
            <p>
              We implement appropriate security measures to protect your data. However, no method is 100% secure. Use the service at your own risk.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">7. Data Retention</h3>
            <p>
              We retain your data as long as your account is active or as needed for legal or business purposes. You may request deletion of your account and associated data.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">8. Your Rights</h3>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Request a copy of your stored data</li>
              <li>Request deletion or correction of your data</li>
              <li>Withdraw consent for optional data uses</li>
            </ul>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">9. Updates to Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Continued use of Poppyruz after updates indicates your acceptance of the changes.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">10. Contact Us</h3>
            <p>
              For questions, reach out to:
            </p>
            <ul className="list-none ml-4">
              <li>📧 mohamedzindha21@gmail.com</li>
            </ul>
          </section>

        </div>
        <div className="text-right mt-6">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
